// extracted by mini-css-extract-plugin
export default {"element":"LinkList-module--element--08048"};